<template>
	<div class="appindex">
	
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		created() {
			this.CSH()
		},
		methods: {
			CSH() {
				this.$post('k=index')
			}
		}
	}
</script>
<style scoped>
	.el-row {
		margin-bottom: 20px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.el-col {
		border-radius: 4px;
	}

	.bg-purple-dark {
		background: #99a9bf;
	}

	.bg-purple {
		background: #d3dce6;
	}

	.bg-purple-light {
		background: #e5e9f2;
	}

	.grid-content {
		border-radius: 4px;
		min-height: 36px;
	}

	.row-bg {
		padding: 10px 0;
		background-color: #f9fafc;
	}

	.el-input__inner {
		background-color: rgba(255, 255, 255, 0) !important;
		border: none !important;
	}

	.el-select .el-input .el-select__caret {
		color: #FFFFFF;
	}

	.el-input__inner {
		color: #FFFFFF;
	}

	.index_t1 {
		height: 40px;
		background-color: rgba(255, 255, 255, 0.2);
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.index_t2 {
		padding-right: 10px;
		color: #FFFFFF;
		font-size: 26px;
	}

	.index_t2_ {
		padding-right: 10px;
		color: #FFFFFF;
		font-size: 14px;
	}

	.index_t3 {
		width: 50%;
		font-size: 40px;
		padding: 10px 0 10px 10px;
		color: #FFFFFF;
	}

	.index_t4 {
		width: 50%;
		display: flex;
		justify-content: flex-end;
		padding: 15px 10px 0 0;
		font-size: 20px;
		color: #FFFFFF;
	}

	.index_t5 {
		height: 40px;
		background-color: rgba(255, 255, 255, 0.2);
		display: flex;
		align-items: center;
	}

	.index_t6 {
		padding-left: 10px;
		color: #FFFFFF;
	}

	.index_t7 {
		width: 65%;
		background-color: #FFFFFF;
		padding: 10px 10px 0 10px;
	}

	.index_t8 {
		margin-top: 20px;
		display: flex;
		justify-content: space-between;
	}

	.index_t9 {
		width: 30%;
		background-color: #FFFFFF;
		padding: 10px 10px 0 10px;
	}

	.index_t10 {
		display: flex;
		position: relative;
	}

	.index_t11 {
		font-size: 16px;
		color: #FFFFFF;
		padding: 4px 0;
	}

	.index_t12 {
		font-size: 16px;
		color: #FFFFFF;
	}

	.index_t12_ {
		font-size: 16px;
		color: #FFFFFF;
		padding-right: 10px;
	}
</style>
